import { Button, Row, Col, Card } from "antd";
import React, { useEffect, useState } from "react";
import DashboardTable from "./DashboardTable";
import { useNavigate } from "react-router-dom";
import SuccessStatCard from "../landingPage/successStats/SuccessStatCard";
import Sidebar from "../../Global/Sidebar"; // Import Sidebar
import { useDispatch, useSelector } from "react-redux";
import { getUserRoleAndStep } from "../../Pages/auth/PrivateRoute";





const Dashboard = () => {
 const dispatch =  useDispatch();
  const navigate = useNavigate();
  const isMenuOpen = useSelector((state) => state.sidebar.isMenuOpen);
  
  useEffect(()=>{
    const getUser = async()=>{
      const user = await getUserRoleAndStep(dispatch)
      console.log("user details:",user)
  
  }
  getUser()
  },[])
  
  return (
    <>
      {/* <Sidebar isMenuOpen={isSidebarOpen} toggleMenu={toggleSidebar} /> */}
      
      <div
        className={`bg-[#41c0e0] sm:p-4  h-full min-h-[100vh] p-8  ${
          isMenuOpen ? "ml-64" : "ml-10"
        } transition-all duration-300 `}
      >
        <div className="flex flex-col sm:flex-row justify-end mb-8">
          <Button
            type="primary"
            className="mr-4 mb-4 sm:mb-0 bg-[#2d98b3]"
            onClick={() => navigate("/dashboard/campaign")}
          >
            Create Campaign
          </Button>
          <Button
            className="bg-[#2d98b3] hover:bg-gray-800 text-white"
            type="primary"
            onClick={() => navigate("/dashboard/fundraiser")}
          >
            Create Fundraiser
          </Button>
        </div>

        <Row gutter={[16, 16]} className="mb-8">
          <Col xs={24} sm={12} md={8}>
            <SuccessStatCard
              headerTag="Total Active Campaigns"
              count="2,673"
             
            />
          </Col>
          <Col xs={24} sm={12} md={8}>
            <SuccessStatCard
              headerTag="Total Ended Campaigns"
              count="2,673"
           
            />
          </Col>
          <Col xs={24} sm={12} md={8}>
            <SuccessStatCard
              headerTag="Total Raised"
              count="₹2,673"
            
            />
          </Col>
        </Row>

        <div className="mt-8">
          <Card className="rounded-lg shadow-sm">
            <DashboardTable />
          </Card>
        </div>
      </div>
    </>
  );
};

export default Dashboard;